export default __webpack_public_path__ + "media/titles/title_4_locale_tr-b0d6e2e3.png";